import { createStore } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { ICodeEntry, StoreSlice } from '@/store';
import { EntryType } from '@morph-mapper/types';

export interface EntryProps {
  id: string;
}

export type InitEntryProps = EntryProps;

export interface EntryState extends EntryProps {}

export type EntryStore = ReturnType<typeof createEntryStore>;

export const createEntryStore = (
  global: StoreSlice,
  initProps: InitEntryProps
) => {
  return createStore<EntryState & StoreSlice & ICodeEntry>()(
    immer((set, get) => ({
      ...global,
      ...global.entries.entry(initProps.id, EntryType.Code),
      ...initProps,
    }))
  );
};
